"use strict";
exports.__esModule = true;
exports.icons = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("../Themes/styled-components"));
var icons_1 = tslib_1.__importDefault(require("./icons"));
var Wrapper = styled_components_1["default"].span(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n"], ["\n  display: inline-flex;\n  align-items: center;\n"])));
var SocialIcon = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 32 : _b, variant = _a.variant, className = _a.className, name = _a.name, restProps = tslib_1.__rest(_a, ["size", "variant", "className", "name"]);
    return (React.createElement(Wrapper, tslib_1.__assign({ className: "social-icon ".concat(className) }, restProps), name in icons_1["default"] ? icons_1["default"][name](size, variant) : null));
};
exports["default"] = SocialIcon;
var icons_2 = require("./icons");
tslib_1.__createBinding(exports, icons_2, "default", "icons");
var templateObject_1;
